let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("akeoo")).then(() => parcelRequire('c0dfk'));